"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserChangePasswordDto = exports.UserChangePasswordRequestDto = exports.UserResponseWithPasswordDto = exports.UserResponseDto = exports.UserUpdateRequestDto = exports.UserCreateRequestDto = void 0;
class UserCreateRequestDto {}
exports.UserCreateRequestDto = UserCreateRequestDto;
class UserUpdateRequestDto {}
exports.UserUpdateRequestDto = UserUpdateRequestDto;
class UserResponseDto {}
exports.UserResponseDto = UserResponseDto;
class UserResponseWithPasswordDto extends UserResponseDto {}
exports.UserResponseWithPasswordDto = UserResponseWithPasswordDto;
class UserChangePasswordRequestDto {}
exports.UserChangePasswordRequestDto = UserChangePasswordRequestDto;
class UserChangePasswordDto {}
exports.UserChangePasswordDto = UserChangePasswordDto;